<template>
	<div class="table-mobile">
		<table class="w-100 head-table">
			<thead>
					<div class="d-flex space-around background-header bold">
						<p>Precio Unitario</p>
						<p>Cantidad</p>
						<p>Precio Sub</p>
					</div>
					<tr v-for="(item, index) in rows" :key="index">
						<div class="description-product txt-center bold">
							<span>{{item.productName}}</span>
							<button
								v-if="orderState === 'GIVEN'"
								class="btn-table"
								title="Calificar producto"
								@click="$emit('rating', item)">
								<img 
									src="/static/img/icons/comments.svg" 
									alt="Ver detalle"
									class="table-view"
								>
							</button>
						</div>
						<div class="d-flex space-around w-100 text-row">
							<p> PEN {{item.salePrice}}</p>
							<p>{{item.quantity}}</p>
							<p> PEN {{item.total}}</p>
						</div>
					</tr>
			</thead>
		</table>
	</div>
</template>

<script>

export default {
	name: 'table-detail-product-mobile',
	props: {
		orderState: {
			default: '',
			type: String,
		},
		rows: {
			default: () => [],
			type: Array,
		},
	},
};
</script>

<style lang="scss" scoped>
.background-header {
	background-color: color(backgroundTableDetail);
	font-size: color(small);
}

.table-mobile {
	border: 0.1rem solid color(border-grey);
}

th {
	background-color: color(backgroundTableDetail);
	padding: 1.8rem;
}

table {
	border-collapse: collapse;
}

.description-product {
	align-items: center;
	background-color: color(grayMedium);
	display: flex;
	font-size: color(medium);
	justify-content: space-between;
	padding: 1.3rem;
}

.text-row {
	font-size: color(medium);
}
</style>



// WEBPACK FOOTER //
// table-detail-product-mobile.vue?4dbc3020